import styled from 'styled-components';

const Body = styled.p`
  font-size: 16px;
  font-weight: ${(props) => props.fontWeight || 'normal'};
  text-align: ${(props) => props.textAlign || 'inherit'};
  color: ${(props) => props.color || props.theme.bodyColor};
  text-transform: ${(props) => props.textTransform || 'unset'};
  margin: 0;
  font-family: ${(props) => props.theme.secondaryFontFontFamily};
`;

export default Body;
